export default __webpack_public_path__ + "static/video-banner-1547a026a55561c60fdb70fc7203b053.mp4";